<div class="home-container">
  <div
    id="overlay"
    class="spinner spinner-full-loader"
    *ngIf="showFullLoader"
  >
    <i
      class="pi pi-spin pi-spinner"
      style="font-size: 5rem; margin-bottom: 100px"
    ></i>
  </div>

  <div
    class="home-sidebar"
    *ngIf="chats$ | async as chats; else loader"
    [ngClass]="{
      'show-mobile-sidebar': !loadChatView && isSmallView,
      'hide-mobile-sidebar': loadChatView && isSmallView
    }"
  >
    <h1 class="page-title">{{ companyName$ | async }}</h1>
    <app-chat-search
      (selectChat)="chatResult($event.channel, $event.projectId)"
    ></app-chat-search>
    <div class="panels">
      <!-- Projects-->
      @if (currentAppView() === "buyer") {
        <p-panel
          iconPos="center"
          toggler="header"
          expandIcon="pi pi-angle-up"
          collapseIcon="pi pi-angle-down"
          [toggleable]="true"
          styleClass="sidebar-panels"
        >
          <ng-template pTemplate="header">
            <div class="title">Sourcing</div>
            <p-badge
              class="unread-badge"
              severity="info"
              *ngIf="projectsHaveUnreadChats(chats.sourcingProjects)"
            ></p-badge>
            <div class="action">
              <s-button
                type="tertiary"
                icon="pi pi-plus"
                size="small"
                (click)="newProject($event, 'sourcing')"
              ></s-button>
              <p-overlayPanel
                #projectlimit
                styleClass="gray-overlay project-limit-overlay"
              >
                <app-project-limit-popover
                  [isAdmin]="isAdmin"
                ></app-project-limit-popover>
              </p-overlayPanel>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <div
              class="projects"
              *ngFor="
                let project of chats.sourcingProjects
                  | projectOpportunityChannelSort
              "
            >
              <p-accordion
                expandIcon="pi pi-angle-down"
                collapseIcon="pi pi-angle-up"
                styleClass="sidebar-project-panels"
              >
                <p-accordionTab
                  transitionOptions="50ms cubic-bezier(0.86, 0, 0.07, 1)"
                  expandIcon="pi pi-angle-down"
                  collapseIcon="pi pi-angle-up"
                  styleClass="sidebar-project-panels"
                  [selected]="
                    openProjectAndOpportunityChatAccordions().has(project.name)
                  "
                  (selectedChange)="
                    updateChatAccordionStates($event, project.name)
                  "
                >
                  <ng-template pTemplate="header">
                    <div
                      class="project-name"
                      [pTooltip]="project.name.length > 20 ? project.name : ''"
                    >
                      <span
                        [ngClass]="{
                          unread: hasUnreadChat(project)
                        }"
                      >
                        {{ project.name }}
                      </span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div
                      class="project"
                      (click)="
                        showEmptyProjects = false;
                        showChatContainer = true;
                        loadChatView = true
                      "
                      [routerLink]="[
                        '/',
                        'home',
                        'projects',
                        project.name,
                        'notes'
                      ]"
                      [ngClass]="{
                        selected:
                          selectedChannel?.id ===
                          project.teamMessagesChannel.channel,
                        unread: project.teamMessagesChannel.isUnread
                      }"
                    >
                      <div
                        class="selected-bullet"
                        *ngIf="
                          selectedChannel?.id ===
                          project.teamMessagesChannel.channel
                        "
                      ></div>
                      <div class="status-icon"><i class="pi pi-users"></i></div>
                      <span class="text">Team Messages</span>
                    </div>
                    <ng-container
                      *ngIf="
                        project.channels
                          | filterProjectMembers as projectChannels
                      "
                    >
                      <ng-container *ngIf="projectChannels.shortList.length">
                        <div class="project-separator"></div>
                        <ng-container
                          *ngFor="let chat of projectChannels.shortList"
                        >
                          <div
                            class="project"
                            (click)="
                              showEmptyProjects = false;
                              showChatContainer = true;
                              loadChatView = true
                            "
                            [routerLink]="[
                              '/',
                              'home',
                              'projects',
                              project.name,
                              chat.alias
                            ]"
                            [ngClass]="{
                              selected: selectedChannel?.id === chat.channel,
                              unread: chat.isUnread
                            }"
                          >
                            <div
                              class="selected-bullet"
                              *ngIf="selectedChannel?.id === chat.channel"
                            ></div>
                            <div
                              class="status-icon"
                              [ngClass]="{
                                'sent-icon': chat.hasQuotes,
                                'no-quote-icon': chat.status === 5,
                                'pending-icon': chat.status === 0,
                                'waiting-quote-icon':
                                  chat.status === 1 && !chat.hasQuotes
                              }"
                              [pTooltip]="
                                chat.hasQuotes
                                  ? 'Quote received'
                                  : chat.status === 5
                                    ? 'No quote'
                                    : chat.status === 0
                                      ? 'No response'
                                      : chat.status === 1 && !chat.hasQuotes
                                        ? 'Intend to quote'
                                        : ''
                              "
                              tooltipPosition="bottom"
                            ></div>
                            <span class="text">{{ chat.name }}</span>
                            <p-badge
                              severity="info"
                              *ngIf="chat.isUnread"
                            ></p-badge>
                          </div>
                        </ng-container>
                      </ng-container>
                      <div
                        class="project-separator"
                        *ngIf="
                          projectChannels.shortList.length &&
                          projectChannels.requestsToJoin.length
                        "
                      ></div>
                      <ng-container
                        *ngIf="projectChannels.requestsToJoin.length"
                      >
                        @if (!projectChannels.shortList.length) {
                          <div class="project-separator"></div>
                        }
                        <div class="requests-header">
                          <div class="request-badge">R</div>
                          Requests to join
                        </div>
                        <div
                          class="project"
                          *ngFor="let chat of projectChannels.requestsToJoin"
                          (click)="
                            showEmptyProjects = false;
                            showChatContainer = true;
                            loadChatView = true
                          "
                          [routerLink]="[
                            '/',
                            'home',
                            'projects',
                            project.name,
                            chat.alias
                          ]"
                          [ngClass]="{
                            selected: selectedChannel?.id === chat.channel,
                            unread: chat.isUnread
                          }"
                        >
                          <div
                            class="selected-bullet"
                            *ngIf="selectedChannel?.id === chat.channel"
                          ></div>
                          <span class="text">{{ chat.name }}</span>
                          <p-badge
                            severity="info"
                            *ngIf="chat.isUnread"
                          ></p-badge>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-template>
                </p-accordionTab>
              </p-accordion>
            </div>
            <div
              class="item no-content"
              [ngClass]="{ selected: showEmptyProjects }"
              *ngIf="!chats.sourcingProjects.length"
              (click)="
                showEmptyProjects = true;
                showEmptyOpportunities = false;
                showChatContainer = false;
                loadChatView = true
              "
            >
              <div
                *ngIf="showEmptyProjects"
                class="selected-bullet"
              ></div>
              Get started with RFQs
            </div>
          </ng-template>
        </p-panel>
        <p-panel
          iconPos="center"
          toggler="header"
          expandIcon="pi pi-angle-up"
          collapseIcon="pi pi-angle-down"
          [toggleable]="true"
          styleClass="sidebar-panels"
        >
          <ng-template pTemplate="header">
            <div class="title">Procurement</div>
            <p-badge
              class="unread-badge"
              severity="info"
              *ngIf="projectsHaveUnreadChats(chats.procurementProjects)"
            ></p-badge>
            <div class="action">
              <s-button
                type="tertiary"
                icon="pi pi-plus"
                size="small"
                (click)="newProject($event, 'procurement')"
              ></s-button>
              <p-overlayPanel
                #projectlimit
                styleClass="gray-overlay project-limit-overlay"
              >
                <app-project-limit-popover
                  [isAdmin]="isAdmin"
                ></app-project-limit-popover>
              </p-overlayPanel>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <div
              class="projects"
              *ngFor="
                let project of chats.procurementProjects
                  | projectOpportunityChannelSort
              "
            >
              <p-accordion
                expandIcon="pi pi-angle-down"
                collapseIcon="pi pi-angle-up"
                styleClass="sidebar-project-panels"
              >
                <p-accordionTab
                  transitionOptions="50ms cubic-bezier(0.86, 0, 0.07, 1)"
                  expandIcon="pi pi-angle-down"
                  collapseIcon="pi pi-angle-up"
                  styleClass="sidebar-project-panels"
                  [selected]="
                    openProjectAndOpportunityChatAccordions().has(project.name)
                  "
                  (selectedChange)="
                    updateChatAccordionStates($event, project.name)
                  "
                >
                  <ng-template pTemplate="header">
                    <div
                      class="project-name"
                      [pTooltip]="project.name.length > 20 ? project.name : ''"
                    >
                      <span
                        [ngClass]="{
                          unread: hasUnreadChat(project)
                        }"
                      >
                        {{ project.name }}
                      </span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div
                      class="project"
                      (click)="
                        showEmptyProjects = false;
                        showChatContainer = true;
                        loadChatView = true
                      "
                      [routerLink]="[
                        '/',
                        'home',
                        'projects',
                        project.name,
                        'notes'
                      ]"
                      [ngClass]="{
                        selected:
                          selectedChannel?.id ===
                          project.teamMessagesChannel.channel,
                        unread: project.teamMessagesChannel.isUnread
                      }"
                    >
                      <div
                        class="selected-bullet"
                        *ngIf="
                          selectedChannel?.id ===
                          project.teamMessagesChannel.channel
                        "
                      ></div>
                      <div class="status-icon"><i class="pi pi-users"></i></div>
                      <span class="text">Team Messages</span>
                    </div>
                    <ng-container
                      *ngIf="
                        project.channels
                          | filterProjectMembers as projectChannels
                      "
                    >
                      <ng-container *ngIf="projectChannels.shortList.length">
                        <div class="project-separator"></div>
                        <ng-container
                          *ngFor="let chat of projectChannels.shortList"
                        >
                          <div
                            class="project"
                            (click)="
                              showEmptyProjects = false;
                              showChatContainer = true;
                              loadChatView = true
                            "
                            [routerLink]="[
                              '/',
                              'home',
                              'projects',
                              project.name,
                              chat.alias
                            ]"
                            [ngClass]="{
                              selected: selectedChannel?.id === chat.channel,
                              unread: chat.isUnread
                            }"
                          >
                            <div
                              class="selected-bullet"
                              *ngIf="selectedChannel?.id === chat.channel"
                            ></div>
                            <div
                              class="status-icon"
                              [ngClass]="{
                                'sent-icon': chat.hasQuotes,
                                'no-quote-icon': chat.status === 5,
                                'pending-icon': chat.status === 0,
                                'waiting-quote-icon':
                                  chat.status === 1 && !chat.hasQuotes
                              }"
                              [pTooltip]="
                                chat.hasQuotes
                                  ? 'Quote received'
                                  : chat.status === 5
                                    ? 'No quote'
                                    : chat.status === 0
                                      ? 'No response'
                                      : chat.status === 1 && !chat.hasQuotes
                                        ? 'Intend to quote'
                                        : ''
                              "
                              tooltipPosition="bottom"
                            ></div>
                            <span class="text">{{ chat.name }}</span>
                            <p-badge
                              severity="info"
                              *ngIf="chat.isUnread"
                            ></p-badge>
                          </div>
                        </ng-container>
                      </ng-container>
                      <div
                        class="project-separator"
                        *ngIf="
                          projectChannels.shortList.length &&
                          projectChannels.requestsToJoin.length
                        "
                      ></div>
                      <ng-container
                        *ngIf="projectChannels.requestsToJoin.length"
                      >
                        @if (!projectChannels.shortList.length) {
                          <div class="project-separator"></div>
                        }
                        <div class="requests-header">
                          <div class="request-badge">R</div>
                          Requests to join
                        </div>
                        <div
                          class="project"
                          *ngFor="let chat of projectChannels.requestsToJoin"
                          (click)="
                            showEmptyProjects = false;
                            showChatContainer = true;
                            loadChatView = true
                          "
                          [routerLink]="[
                            '/',
                            'home',
                            'projects',
                            project.name,
                            chat.alias
                          ]"
                          [ngClass]="{
                            selected: selectedChannel?.id === chat.channel,
                            unread: chat.isUnread
                          }"
                        >
                          <div
                            class="selected-bullet"
                            *ngIf="selectedChannel?.id === chat.channel"
                          ></div>
                          <span class="text">{{ chat.name }}</span>
                          <p-badge
                            severity="info"
                            *ngIf="chat.isUnread"
                          ></p-badge>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-template>
                </p-accordionTab>
              </p-accordion>
            </div>
            <div
              class="item no-content"
              [ngClass]="{ selected: showEmptyProjects }"
              *ngIf="!chats.sourcingProjects.length"
              (click)="
                showEmptyProjects = true;
                showEmptyOpportunities = false;
                showChatContainer = false;
                loadChatView = true
              "
            >
              <div
                *ngIf="showEmptyProjects"
                class="selected-bullet"
              ></div>
              Get started with RFQs
            </div>
          </ng-template>
        </p-panel>
      }

      <!-- Opportunities-->
      @if (currentAppView() === "supplier") {
        <p-panel
          iconPos="center"
          toggler="header"
          expandIcon="pi pi-angle-up"
          collapseIcon="pi pi-angle-down"
          [toggleable]="true"
          styleClass="sidebar-panels"
        >
          <ng-template pTemplate="header">
            <div class="title">Opportunities</div>
            <div class="action">
              <s-button
                type="tertiary"
                icon="pi pi-plus"
                size="small"
                (click)="newOpportunityOrder($event, 'opportunity')"
              ></s-button>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <div
              class="items opportunity-chat-item"
              *ngFor="
                let opportunity of chats.sourcingOpportunities
                  | projectOpportunityChannelSort
              "
            >
              <p-accordion
                expandIcon="pi pi-angle-down"
                collapseIcon="pi pi-angle-up"
                styleClass="sidebar-project-panels"
              >
                <p-accordionTab
                  transitionOptions="50ms cubic-bezier(0.86, 0, 0.07, 1)"
                  expandIcon="pi pi-angle-down"
                  collapseIcon="pi pi-angle-up"
                  styleClass="sidebar-project-panels"
                  [selected]="
                    openProjectAndOpportunityChatAccordions().has(
                      opportunity.opportunityId
                    )
                  "
                  (selectedChange)="
                    updateChatAccordionStates($event, opportunity.opportunityId)
                  "
                  (click)="
                    showEmptyProjects = false;
                    showChatContainer = true;
                    loadChatView = true
                  "
                  [routerLink]="[
                    '/',
                    'home',
                    'opportunities',
                    opportunity.opportunityId
                  ]"
                >
                  <ng-template pTemplate="header">
                    <div
                      class="project-name"
                      [ngClass]="{
                        selected:
                          selectedChannel?.id === opportunity.channel &&
                          !showEmptyOpportunities &&
                          !showEmptyProjects,
                        unread: opportunity.isUnread
                      }"
                    >
                      <div
                        class="selected-bullet"
                        *ngIf="
                          selectedChannel?.id === opportunity.channel &&
                          !showEmptyOpportunities &&
                          !showEmptyProjects
                        "
                      ></div>

                      {{ opportunity.name }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div
                      class="project"
                      (click)="
                        showEmptyProjects = false;
                        showChatContainer = true;
                        loadChatView = true;
                        $event.stopPropagation()
                      "
                      [routerLink]="[
                        '/',
                        'home',
                        'opportunities',
                        opportunity.opportunityId,
                        'notes'
                      ]"
                      [ngClass]="{
                        selected:
                          selectedChannel?.id ===
                          opportunity.teamMessagesChannel.channel,
                        unread: opportunity.teamMessagesChannel.isUnread
                      }"
                    >
                      <div
                        class="selected-bullet"
                        *ngIf="
                          selectedChannel?.id ===
                          opportunity.teamMessagesChannel.channel
                        "
                      ></div>
                      <div class="status-icon"><i class="pi pi-users"></i></div>
                      <span class="text">Team Messages</span>
                    </div>
                  </ng-template>
                </p-accordionTab>
              </p-accordion>
            </div>
            <div
              class="item no-content"
              [ngClass]="{ selected: showEmptyOpportunities }"
              *ngIf="!chats.sourcingOpportunities.length"
              (click)="
                showEmptyOpportunities = true;
                showEmptyProjects = false;
                showChatContainer = false;
                loadChatView = true
              "
            >
              <div
                *ngIf="showEmptyOpportunities"
                class="selected-bullet"
              ></div>
              Get started with Opportunities
            </div>
          </ng-template>
        </p-panel>
        <p-panel
          iconPos="center"
          toggler="header"
          expandIcon="pi pi-angle-up"
          collapseIcon="pi pi-angle-down"
          [toggleable]="true"
          styleClass="sidebar-panels"
        >
          <ng-template pTemplate="header">
            <div class="title">Orders</div>
            <div class="action">
              <s-button
                type="tertiary"
                icon="pi pi-plus"
                size="small"
                (click)="newOpportunityOrder($event, 'order')"
              ></s-button>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <div
              class="items opportunity-chat-item"
              *ngFor="
                let opportunity of chats.procurementOrders
                  | projectOpportunityChannelSort
              "
            >
              <p-accordion
                expandIcon="pi pi-angle-down"
                collapseIcon="pi pi-angle-up"
                styleClass="sidebar-project-panels"
              >
                <p-accordionTab
                  transitionOptions="50ms cubic-bezier(0.86, 0, 0.07, 1)"
                  expandIcon="pi pi-angle-down"
                  collapseIcon="pi pi-angle-up"
                  styleClass="sidebar-project-panels"
                  [selected]="
                    openProjectAndOpportunityChatAccordions().has(
                      opportunity.opportunityId
                    )
                  "
                  (selectedChange)="
                    updateChatAccordionStates($event, opportunity.opportunityId)
                  "
                  (click)="
                    showEmptyProjects = false;
                    showChatContainer = true;
                    loadChatView = true
                  "
                  [routerLink]="[
                    '/',
                    'home',
                    'opportunities',
                    opportunity.opportunityId
                  ]"
                >
                  <ng-template pTemplate="header">
                    <div
                      [ngClass]="{
                        selected:
                          selectedChannel?.id === opportunity.channel &&
                          !showEmptyOpportunities &&
                          !showEmptyProjects,
                        unread: opportunity.isUnread
                      }"
                    >
                      <div
                        class="selected-bullet"
                        *ngIf="
                          selectedChannel?.id === opportunity.channel &&
                          !showEmptyOpportunities &&
                          !showEmptyProjects
                        "
                      ></div>

                      {{ opportunity.name }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div
                      class="project"
                      (click)="
                        showEmptyProjects = false;
                        showChatContainer = true;
                        loadChatView = true;
                        $event.stopPropagation()
                      "
                      [routerLink]="[
                        '/',
                        'home',
                        'opportunities',
                        opportunity.opportunityId,
                        'notes'
                      ]"
                      [ngClass]="{
                        selected:
                          selectedChannel?.id ===
                          opportunity.teamMessagesChannel.channel,
                        unread: opportunity.teamMessagesChannel.isUnread
                      }"
                    >
                      <div
                        class="selected-bullet"
                        *ngIf="
                          selectedChannel?.id ===
                          opportunity.teamMessagesChannel.channel
                        "
                      ></div>
                      <div class="status-icon"><i class="pi pi-users"></i></div>
                      <span class="text">Team Messages</span>
                    </div>
                  </ng-template>
                </p-accordionTab>
              </p-accordion>
            </div>
            <div
              class="item no-content"
              [ngClass]="{ selected: showEmptyOpportunities }"
              *ngIf="!chats.procurementOrders.length"
              (click)="
                showEmptyOpportunities = true;
                showEmptyProjects = false;
                showChatContainer = false;
                loadChatView = true
              "
            >
              <div
                *ngIf="showEmptyOpportunities"
                class="selected-bullet"
              ></div>
              Get started with Opportunities
            </div>
          </ng-template>
        </p-panel>
      }

      <!-- Companies -->
      <p-panel
        iconPos="center"
        toggler="header"
        expandIcon="pi pi-angle-up"
        collapseIcon="pi pi-angle-down"
        [toggleable]="true"
        styleClass="sidebar-panels"
      >
        <ng-template pTemplate="header">
          <div class="title">Companies</div>
          <div class="action">
            <s-button
              type="tertiary"
              icon="pi pi-plus"
              size="small"
              (click)="newChat($event)"
            ></s-button>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <ng-container
            *ngIf="
              chats.companies
                | filterCompanies
                  : companiesExpanded
                  : selectedChannel?.id as result
            "
          >
            <div
              class="items"
              *ngFor="let company of result.channels"
              (click)="
                showEmptyProjects = false;
                showChatContainer = true;
                showEmptyOpportunities = false;
                loadChatView = true
              "
              [routerLink]="['/', 'home', 'companies', company.alias]"
            >
              <div
                *ngIf="company.name"
                class="item"
                [ngClass]="{
                  selected:
                    selectedChannel?.id === company.channel &&
                    !showEmptyOpportunities &&
                    !showEmptyProjects,
                  unread: company.isUnread
                }"
              >
                <div
                  class="selected-bullet"
                  *ngIf="
                    selectedChannel?.id === company.channel &&
                    !showEmptyOpportunities &&
                    !showEmptyProjects
                  "
                ></div>
                {{ company.name }}
              </div>
            </div>
            <div class="expand-button">
              <s-button
                type="tertiary"
                *ngIf="result.showMore"
                [label]="companiesExpanded ? 'Show Less' : 'Show More'"
                (click)="companiesExpanded = !companiesExpanded"
              ></s-button>
            </div>
          </ng-container>
        </ng-template>
      </p-panel>
    </div>
  </div>

  <div
    class="home-main"
    [ngClass]="{
      'show-mobile-chat': loadChatView && isSmallView,
      'hide-mobile-chat': !loadChatView && isSmallView
    }"
  >
    <ng-container *ngIf="showEmptyOpportunities">
      <app-dashboard-no-results-opportunities
        (back)="onBack()"
      ></app-dashboard-no-results-opportunities>
    </ng-container>
    <ng-container *ngIf="showEmptyProjects">
      <app-dashboard-no-results-projects
        [canCreateProjects]="canCreateProjects"
        (back)="onBack()"
      ></app-dashboard-no-results-projects>
    </ng-container>
    <ng-container *ngIf="showChatContainer">
      <ng-container *ngIf="conversation$ | async as conversation">
        <div class="header">
          <div class="main-title">
            <div class="col-left">
              <div
                class="back"
                (click)="onBack()"
              >
                <span class="pi pi-arrow-left"></span>
              </div>
              <div class="title-wrapper">
                <div class="company-name-wrapper">
                  @if (
                    !conversation.opportunityId && !conversation.isTeamMessages
                  ) {
                    <img
                      [class]="
                        conversation.logoUrl.includes('NoLogo') ? '' : 'logo'
                      "
                      [src]="conversation.logoUrl"
                      [alt]="conversation.recipientName"
                      width="42px"
                      loading="lazy"
                    />
                  }
                  <h2
                    [ngClass]="{
                      'company-name': true,
                      'is-team-messages': conversation.isTeamMessages
                    }"
                  >
                    <ng-container
                      *ngIf="
                        conversation.menu[0]?.label === 'Go to project';
                        else vendorNameTemplate
                      "
                    >
                      <span (click)="onHeaderClick(conversation)">{{
                        conversation.recipientName
                      }}</span>
                    </ng-container>
                    <ng-template #vendorNameTemplate>
                      <a
                        [routerLink]="
                          !conversation.isTeamMessages
                            ? getProfileUrl(conversation)
                            : ''
                        "
                      >
                        {{ conversation.recipientName }}
                      </a>
                    </ng-template>
                  </h2>
                  @if (!conversation.isTeamMessages) {
                    <ng-container
                      *ngIf="
                        !selectedChannel?.isRegistered &&
                        selectedChannel?.projectId
                      "
                    >
                      <span class="separator"> | </span>
                      <p-chip
                        [label]="'Unregistered'"
                        [styleClass]="'supplier-status-added'"
                      ></p-chip>
                    </ng-container>
                    <ng-container *ngIf="supplierStatus$ | async as status">
                      <span class="separator"> | </span>
                      <p-chip
                        [label]="status.label"
                        [styleClass]="'supplier-status-' + status.key"
                        class="supplier-status"
                      ></p-chip>
                    </ng-container>
                    <ng-container *ngIf="nda$ | async">
                      <span class="separator"> | </span>
                      <p-chip
                        label="NDA"
                        removeIcon="pi pi-times"
                        styleClass="nda"
                      ></p-chip>
                    </ng-container>
                    @if (!!purchaseOrder()) {
                      <ng-container>
                        <span class="separator"> | </span>
                        <app-purchase-order-supplier-acknowledgement
                          [purchaseOrder]="purchaseOrder()!"
                          [supplierName]="conversation.recipientName"
                        />
                      </ng-container>
                    } @else if (isLoadingPurchaseOrder()) {
                      <ng-container>
                        <i class="pi pi-spin pi-spinner"></i>
                      </ng-container>
                    }
                  }
                </div>
                <div *ngIf="conversation.projectName">
                  <a
                    class="title-project-name"
                    [href]="
                      !!opportunityId()
                        ? '/opportunities/quoting' + opportunityId()
                        : '/projects/' + selectedChannel?.projectId
                    "
                    target="_blank"
                  >
                    {{ conversation.projectName }}
                    <i class="pi pi-external-link"></i>
                  </a>
                  @if (conversation.projectStatus !== undefined) {
                    <span class="separator"> | </span>
                    <app-project-member-status-selector
                      [preselectedStatus]="conversation.projectStatus"
                      [memberId]="conversation.vendorSustainmentId"
                      [projectId]="conversation.projectId!"
                    ></app-project-member-status-selector>
                  }
                </div>
              </div>
            </div>
            <div class="col-right">
              <div *ngIf="conversation.isTeamMessages">
                <div *ngIf="conversation.opportunityId">
                  <div
                    class="spinner"
                    *ngIf="isLoadingOpportunityTeamMembers"
                  >
                    <i class="pi pi-spin pi-spinner"></i>
                  </div>
                  <div *ngIf="!isLoadingOpportunityTeamMembers">
                    <app-opportunity-team-popover
                      *ngIf="opportunityTeamMembers$ | async as teamMember"
                      [team]="teamMember"
                      (userAdded)="
                        addUserToOpportunityTeam(conversation, $event)
                      "
                      (userRemoved)="
                        removeUserFromOpportunityTeam(conversation, $event)
                      "
                      (userLeft)="onUserLeftOpportunityTeam(conversation)"
                    ></app-opportunity-team-popover>
                  </div>
                </div>
                <div *ngIf="!conversation.opportunityId">
                  <div
                    class="spinner"
                    *ngIf="isLoadingTeamMembers"
                  >
                    <i class="pi pi-spin pi-spinner"></i>
                  </div>
                  <app-project-team-popover
                    *ngIf="teamMembers$ | async as teammember"
                    [activeTeam]="teammember.members"
                    [orgUsers]="teammember.nonMembers"
                    [canLeave]="!userIsCreator && isTeamMember"
                    [canRemoveUsers]="userIsCreator"
                    (userAdded)="onUserAddedToTeam($event)"
                    (userRemoved)="onUserRemovedFromTeam($event)"
                    (userLeft)="leaveTeam()"
                  ></app-project-team-popover>
                </div>
              </div>
              <div
                class="item-menu"
                *ngIf="conversation.menu?.length"
              >
                <div class="kebab-menu">
                  <s-button
                    type="tertiary"
                    size="small"
                    icon="pi pi-ellipsis-v"
                    (click)="menu.toggle($event)"
                  ></s-button>
                  <p-menu
                    #menu
                    [model]="conversation.menu"
                    [popup]="true"
                    appendTo="body"
                    styleClass="kebab-menu"
                  ></p-menu>
                </div>
              </div>
            </div>
          </div>
          <div class="tabs">
            <div class="tabs-label">Messages</div>
          </div>
        </div>
        <div
          class="main-container"
          [ngClass]="{ 'extra-space': conversation.projectName }"
        >
          <div
            class="top-notifications"
            appTopNotificationsScroll
          >
            <!-- Supplier email validation -->
            <app-supplier-email-confirmation
              *ngIf="supplierEmail && !supplierEmail.isConfirmed"
              [vendorLogo]="conversation.logoUrl"
              [vendorName]="conversation.recipientName"
              [vendorSustainmentId]="conversation.vendorSustainmentId"
              [supplierEmail]="supplierEmail.email"
              (vendorClicked)="openProfile(conversation)"
              (emailConfirmed)="emailConfirmed(conversation, $event.email)"
            >
            </app-supplier-email-confirmation>
            <!-- NDA signature -->
            <app-sign-nda-component
              *ngIf="signatureRequest"
              [companyLogo]="conversation.logoUrl"
              [requestId]="signatureRequest.id"
              [companyName]="conversation.recipientName"
              [sustainmentId]="sustainmentId"
              [receiverSustainmentId]="conversation.recipientId"
              [requestedByCurrentUser]="!signatureRequest.isIncoming"
              (companyClicked)="openProfile(conversation)"
            ></app-sign-nda-component>
            <!-- Certification update-->
            <div *ngIf="certRequest$ | async as certificationUpdateRequest">
              <app-cert-update-request
                [companyName]="conversation.recipientName"
                [certificationUpdateRequest]="certificationUpdateRequest"
                (companyClicked)="openProfile(conversation)"
              ></app-cert-update-request>
            </div>
            <!-- Connection -->
            <ng-container *ngIf="connectionStatus$ | async as connectionStatus">
              <div
                class="connection-requests"
                *ngIf="connectionStatus.status === 'WantsToConnect'"
              >
                <app-dashboard-connection-request
                  [connectionRequest]="{
                    name: conversation.recipientName,
                    note: connectionStatus.note,
                    logo: conversation.logoUrl,
                    sustainmentId: conversation.vendorSustainmentId
                  }"
                  (connectionAccepted)="acceptConnection(connectionStatus.code)"
                  (connectionDeclined)="declineConnection()"
                  (companyClicked)="openProfile(conversation)"
                >
                </app-dashboard-connection-request>
              </div>
            </ng-container>
            <div
              class="connection-requests"
              *ngIf="projectInvite && !conversation.isTeamMessages"
            >
              <!-- Project invite -->
              <app-dashboard-project-invite-request
                [vendorName]="projectInvite.vendorName"
                [vendorLogo]="conversation.logoUrl"
                [opportunityId]="projectInvite.opportunityId"
                [opportunityName]="conversation.recipientName"
                (invitationAccepted)="projectInviteAccepted()"
                (invitationDenied)="projectInviteDeclined()"
                (companyClicked)="openProfile(conversation)"
                (opportunityClicked)="onHeaderClick(conversation)"
                [intentToQuote]="projectInvite.status === 1"
                [noQuoteStatus]="projectInvite.status === 5"
                [pendingInvite]="
                  projectInvite.status === 0 || !projectInvite.status
                "
              >
              </app-dashboard-project-invite-request>
            </div>
            <div
              class="connection-requests"
              *ngIf="opportunityRequest"
            >
              <app-dashboard-project-community-request
                [vendorName]="conversation.recipientName"
                [vendorLogo]="conversation.logoUrl"
                [vendorSustainmentId]="conversation.vendorSustainmentId"
                [opportunityId]="opportunityRequest.projectId"
                [messages]="conversation.messages"
                (companyClicked)="openProfile(conversation)"
                [projectName]="conversation.projectName"
                [opportunityRequestId]="opportunityRequest.id"
                (invitationAccepted)="projectInviteAccepted('opportunity')"
                (invitationDenied)="projectOwnerInviteDeclined()"
                [hasSupplierRecord]="conversation.hasSupplierRecord"
                [isSupplierRecordArchived]="
                  conversation.isSupplierRecordArchived
                "
              >
              </app-dashboard-project-community-request>
            </div>
          </div>
          <div class="main-chat-room">
            <app-chat-room
              [chat]="conversation"
              [channelId]="selectedChannel?.id"
              (endChat)="onEndChat()"
              (messageSent)="onMessageSent($event.message, $event.thread)"
              [allowFileUploads]="
                !!conversation.menu.length && !conversation.isTeamMessages
              "
              [disabledFileUploads]="!conversation.canUpload"
              (fileClicked)="downloadChatFile($event)"
              (reachedTop)="loadNextPage()"
              [readOnly]="conversation.readonly"
              [isPendingOpportunityRequest]="
                !!opportunityRequest || declinedRequestToJoin
              "
              [origin]="'Dashboard'"
              [lastReadTime]="conversation.lastReadTime"
              [isRegistered]="selectedChannel?.isRegistered"
              (emailClick)="openConfirmationModal(conversation, true)"
              [projectId]="selectedChannel?.projectId"
              [opportunityId]="opportunityId()!"
              [isOfficialSustainmentAccount]="
                conversation.isOfficialSustainmentAccount
              "
              [recipientSustainmentId]="conversation.recipientId"
              [activeTeam]="activeTeam || undefined"
              [threading]="conversation.isTeamMessages"
            ></app-chat-room>
          </div>
        </div>
      </ng-container>

      <div
        class="chat-loader"
        *ngIf="loadingConversation"
      >
        <div class="spinner">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<p-dialog
  header="File History"
  [(visible)]="showFilesModal"
  [draggable]="false"
  [modal]="true"
  (onHide)="files$ = null"
>
  <app-file-history-list-modal
    [files]="files"
    *ngIf="files$ | async as files"
    (downloadFile)="downloadChatFile($event)"
    (deleteFile)="deleteChatFile($event)"
  ></app-file-history-list-modal>
</p-dialog>

<p-dialog
  header="Deleted file or missing permissions"
  [(visible)]="showDeletedModal"
  [draggable]="false"
  [modal]="true"
  >We are sorry but the file you are asking for is missing. Please request it
  again
  <ng-template pTemplate="footer">
    <s-button
      (click)="showDeletedModal = false"
      label="Close"
      [type]="'primary'"
    ></s-button>
  </ng-template>
</p-dialog>

<ng-template #loader>
  <div
    id="overlay"
    class="spinner"
  >
    <i
      class="pi pi-spin pi-spinner"
      style="font-size: 5rem; margin-bottom: 100px"
    ></i>
  </div>
</ng-template>
